import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsNewjapanproWrestlingComponent } from './simple-icons-newjapanpro-wrestling.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsNewjapanproWrestlingComponent ],
    exports:      [ SimpleIconsNewjapanproWrestlingComponent ],
    bootstrap:    []
})
export class SimpleIconsNewjapanproWrestlingModule {}
